import blobStream from 'blob-stream';
import PDFDocument from 'pdfkit';
import registerWorkerPromiseTransferable from 'promise-worker-transferable/register';
import getFeasibilitySVGString from '../../feasibility/exports/getSVGString';
import {
  IOutput as IGeoPNGOutput,
} from '../../geoMap/exports/getPNGDataURL';
import getProductSpaceSVGString from '../../network/exports/getSVGString';
import getRingsSVGString from '../../rings/exports/getSVGString';
import getStackSVGString from '../../stack/exports/getSVGString';
import getTreeSVGString from '../../tree/newExports/getSVGString';
import {
  failIfValidOrNonExhaustive,
} from '../../Utils';
import {
  pdfMIMEType,
} from '../exportsPanel/Utils';
import getPDFGetter from '../getPDF';
import {
  PDFWorkerMessage,
  PDFWorkerMessageType,
} from './Utils';

const getGeoPDF =
  async ({dataURL, canvasHeight, canvasWidth}: IGeoPNGOutput): Promise<Blob> =>
    new Promise<Blob>((resolve, reject) => {

      try {
        const margin = 20;
        const pdfDocument = new PDFDocument({
          size: 'legal',
          layout: 'landscape',
          margin,
        });

        const availableWidth = pdfDocument.page.width - margin - margin;
        const availableHeight = pdfDocument.page.height - margin - margin;

        const intrinsicAspectRatio = canvasWidth / canvasHeight;
        const pageAspectRatio = availableWidth / availableHeight;

        let widthToFit: number, heightToFit: number;
        if (intrinsicAspectRatio > pageAspectRatio) {
          // This means the map is wider than the page
          widthToFit = availableWidth;
          heightToFit = widthToFit / intrinsicAspectRatio;
        } else {
          // This means the map is taller than the page
          heightToFit = availableHeight;
          widthToFit = heightToFit * intrinsicAspectRatio;
        }

        const stream = pdfDocument.pipe(blobStream());
        stream.on('finish', () => {
          const blob = stream.toBlob(pdfMIMEType);
          resolve(blob);
        });
        pdfDocument.image(dataURL, margin, margin, {fit: [widthToFit, heightToFit]});

        pdfDocument.end();

      } catch (e) {
        reject(e);
      }
    });

const getPDF = (input: PDFWorkerMessage): Promise<Blob> => {
  switch (input.type) {
    case PDFWorkerMessageType.TREE_EXPORT_PDF:
      return getPDFGetter(getTreeSVGString)(input.content);

    case PDFWorkerMessageType.GEO_EXPORT_PDF:
      return getGeoPDF(input.content);

    case PDFWorkerMessageType.STACK_EXPORT_PDF:
      return getPDFGetter(getStackSVGString)(input.content);

    case PDFWorkerMessageType.PRODUCT_SPACE_EXPORT_PDF:
      return getPDFGetter(getProductSpaceSVGString)(input.content);

    case PDFWorkerMessageType.FEASIBILITY_EXPORT_PDF:
      return getPDFGetter(getFeasibilitySVGString)(input.content);

    case PDFWorkerMessageType.RINGS_EXPORT_PDf:
      return getPDFGetter(getRingsSVGString)(input.content);

    default:
      failIfValidOrNonExhaustive(input, 'Invalid worker message type');
      // These lines will never be executed:
      return Promise.resolve(new Blob());
  }
};

registerWorkerPromiseTransferable<PDFWorkerMessage, Blob>(
  (message: PDFWorkerMessage) => getPDF(message),
);
